import React from 'react'
import { connect } from 'react-redux'
import Draggable from 'react-draggable'
import _ from 'lodash'
import { slideActions, menuActions, viewsActions } from '../../../actions'
import store from '../../../store'
import { getBoxAbsolutePosition } from '../../../api/boxUtils'
import { getBounds, alignToRulers } from '../../../api/utils'
import { roundCaptionForGrid } from '../functions'
import { getRightPropertyValue } from '../../../../Utils/helpers'

// чтобы перетаскиваемый элемент был всегда сверху, увеличиваем z-index ему и его родительским боксам
// а после отпускания, возвращаем тот z-index, который был у элемента до перетаскивания 
// функция принимает ( сам перетаскиваемый элемент, поднять элемент - boolean )
function setZindex(mainElem, makeAbove) {
    const parentDraggableElement = mainElem.closest('.react-draggable')
    let parentBoxElement = null
    if (parentDraggableElement) {
        if (makeAbove) {
            parentDraggableElement.setAttribute('data-zIndex', parentDraggableElement.style.zIndex || '0')
            parentDraggableElement.style.zIndex = '9999'
            // чтобы шрифт, который выходит за пределы капчи, не оставлял артефактов
            // parentDraggableElement.style.outline = '20px solid transparent';
        } else {
            let oldIndex = '1'
            if (parentDraggableElement.hasAttribute('data-zIndex')) {
                oldIndex = parentDraggableElement.getAttribute('data-zIndex')
                parentDraggableElement.removeAttribute('data-zIndex')
            }
            parentDraggableElement.style.zIndex = oldIndex
            // parentDraggableElement.style.outline = 'none'
        }
        parentBoxElement = parentDraggableElement.closest('.caption-box')
        if (parentBoxElement) {
            setZindex(parentBoxElement, makeAbove)
        }
    }
    return parentBoxElement
}

class DraggableWrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            startDragTime: 0,
        }
        this.intervalFriends = null
        this.isUnmounted = false
    }

    componentDidMount() {
        window.addEventListener('mouseup', () => {
            clearInterval(this.intervalFriends)
        })
    }
    // componentDidUpdate() {
    //     console.log('test');
    //     if(!this.state.test) {
    //         this.setState({test: false})
    //     }
    // }

    // shouldComponentUpdate(){
    //     return false
    // }
    componentWillUnmount() {
        this.isUnmounted = true
    }

    // вызывается при прекращении перемещения
    changeCaptionPosition(index, lastX, lastY, event, timeFromStartIsLittle) {
        lastX = Math.round(lastX)
        lastY = Math.round(lastY)
        // console.log('lastX, lastY',lastX, lastY);
        // прекращаем слушать перемещение капчи
        clearInterval(this.intervalFriends)

        const scale = this.props.mobileViewScale / 100
        const boxElementsList = document.querySelectorAll('.drop-in-me')
        let inBoxCaptionId = null
        let newParentBoxElement = null
        // ищем бокс с тенью - в него и будем вкладывать перетаскиваемый элемент
        for (let i = 0; i < boxElementsList.length; i++) {
            if (boxElementsList[i].classList.contains('drop-in-me')) {
                // определили нового родителя, если вкладываем в бокс
                newParentBoxElement = boxElementsList[i]
                inBoxCaptionId = boxElementsList[i].getAttribute('data-caption-id')
            }
            // удаляем внутреннюю тень, которая обозначает доступность вложения
            boxElementsList[i].classList.remove('drop-in-me')
        }
        const draggedCaption = store.getState().slideReducer.captions[index]
        let mainElem = document.querySelector(`#caption-${index}`);
        if (draggedCaption.type === 'image') {
            mainElem = document.querySelector(`#caption-${index}`).parentElement
        }
        const oldParenBoxElement = setZindex(mainElem, false)
        const isSameBox = newParentBoxElement === oldParenBoxElement
        const isNoBox = newParentBoxElement === null

        event.stopPropagation();
        // проверяю положение координат курсора, сдвинулись ли они
        // проверка на координаты капчи иногда даёт ошибочно положительный ответ, связанный с дробными пикселями в настройках
        // и различными погрешностями при определении положении капч в окне браузера
        const deltaMoveMouseX = event.clientX - this.state.startDragMouseX
        const deltaMoveMouseY = event.clientY - this.state.startDragMouseY
        const mouseNotMowed = deltaMoveMouseX === 0 && deltaMoveMouseY === 0
        // предотвращаю смену вложенности по клику если перемещение ещё не начато
        if (mouseNotMowed) return

        const desktopDims = { width: this.props.widgetData.originalWidth, height: this.props.widgetData.originalHeight }
        const mobileDims = { width: this.props.widgetData.mobileWidth, height: this.props.widgetData.mobileHeight }
        // проверяем, сдвинулась ли капча относительно её первоначального положения
        // если нет, то не проводим с ней манипуляции по перемещению

        // const viewTypePosition = this.props.viewType === 'desktop' ? 'position' : 'mobilePosition'
        const viewTypePosition = getRightPropertyValue(desktopDims, mobileDims, 'position', this.props.viewType === 'mobile', draggedCaption)
        const positionX = draggedCaption.boxId === '' ? 'x' : 'relativeX'
        const positionY = draggedCaption.boxId === '' ? 'y' : 'relativeY'
        // console.log('draggedCaption.position',draggedCaption.position);
        const captionDontMove = viewTypePosition[positionX] === lastX && viewTypePosition[positionY] === lastY

        if (captionDontMove) return

        if (draggedCaption.position.x != lastX || draggedCaption.position.y != lastY) {

            // выравнивание по направляющим рулетки
            let rulersArray = this.props.viewType === 'mobile' ? this.props.rulersArrayMobile : this.props.rulersArray

            if (draggedCaption.boxId != '') {
                const boxInDom = getBoxAbsolutePosition(draggedCaption.boxId)
                lastX += boxInDom.x / scale
                lastY += boxInDom.y / scale
            }
            // если рулетки включены
            // if (this.props.rulers && rulersArray.length > 0) {
            //     const { x, y } = alignToRulers(draggedCaption, rulersArray, lastX, lastY)
            //     lastX = x;
            //     lastY = y;
            // }
            // перетаскивать внутри бокса группу элементов сейчас нельзя
            // if (this.props.captionSelectedArray.length > 1) {

            // } else {
            // если перетаскиваемый элемент находился в боксе
            // if (draggedCaption.boxId != '') {
            // const boxInDom = getBoxAbsolutePosition(draggedCaption.boxId)
            // console.log('before lastX',lastX,'lastY',lastY);
            // lastX += boxInDom.x
            // lastY += boxInDom.y
            // console.log('after lastX',lastX,'lastY',lastY);
            // const {x, y} = alignToRulers(draggedCaption, rulersArray, lastX, lastY, draggedCaption.boxId != '')
            // console.log('x',x,' y', y);
            // lastX = x;
            // lastY = y;
            // }
            // this.props.dispatch(slideActions.changeCaptionPosition(index, lastX, lastY, this.props.viewType))

            // }
            // this.convertAndChangePositionV2(draggedCaption, lastX, lastY)
            // if (!this.props.ctrlIsPress) {
            if (!event.ctrlKey) {

                this.replaceElement(draggedCaption, lastX, lastY, isSameBox, newParentBoxElement, mainElem, isNoBox, inBoxCaptionId)
            } else {
                // console.log('CTRL IS PRESS');
            }
        }
    }

    // переместить элемент вне бокса или поместить элемент внутрь бокса или вынуть его оттуда или переместить внутри бокса
    replaceElement(draggedCaption, lastX, lastY, isSameBox, newParentBoxElement, mainElem, isNoBox, inBoxCaptionId) {
        const mainElemParams = mainElem.getBoundingClientRect()
        const workspace = document.getElementById(`workspace`).getBoundingClientRect()
        const scale = this.props.mobileViewScale / 100
        // если включена сетка, то позиционируем по ней только при отпускании
        if (this.props.gridOn) {
            lastX = roundCaptionForGrid(lastX, 1)
            lastY = roundCaptionForGrid(lastY, 1)
        }

        if ((this.props.currentGrid.x != 1 || this.props.currentGrid.y != 1) && !this.props.gridOn) {
            if (this.props.currentAlign.left != null) {
                switch (this.props.currentAlign.left.type) {
                    case 'left':
                        lastX = this.props.currentAlign.left.position
                        break;
                    case 'center':
                        lastX = this.props.currentAlign.left.position - (mainElemParams.width / 2) / scale
                        break;
                    case 'right':
                        lastX = this.props.currentAlign.left.position - mainElemParams.width / scale
                        break;
                }
            }

            if (this.props.currentAlign.top != null) {
                switch (this.props.currentAlign.top.type) {
                    case 'top':
                        lastY = this.props.currentAlign.top.position
                        break;
                    case 'middle':
                        lastY = this.props.currentAlign.top.position - (mainElemParams.height / 2) / scale
                        break;
                    case 'bottom':
                        lastY = this.props.currentAlign.top.position - mainElemParams.height / scale
                        break;
                }
            }
        }

        // перемещение за пределами боксов
        if (isNoBox && isSameBox) {
            // console.log('isNoBox && isSameBox');
            this.props.dispatch(slideActions.changeCaptionPosition(draggedCaption.index, lastX, lastY, this.props.viewType))
            // this.props.dispatch(slideActions.changeCaptionRelativePosition(draggedCaption.index, lastX, lastY, this.props.viewType))
        }
        // перемещение внутри одного бокса
        else if (isSameBox) {
            // console.log('isSameBox');
            // возникала ошибка, если выделены 2 капчи и кликнуть с ctrl на вложенную в бокс капчу,
            // последняя начинала позиционироваться относительно всего слайда, а не бокса
            if (this.props.captionSelectedArray.length > 1) return
            const newBoxPosition = newParentBoxElement.getBoundingClientRect()
            lastX = lastX - (newBoxPosition.x - workspace.x) / scale;
            lastY = lastY - (newBoxPosition.y - workspace.y) / scale;

            this.props.dispatch(slideActions.changeCaptionRelativePosition(draggedCaption.index, lastX, lastY, this.props.viewType))
        } else {
            if (this.props.viewType === 'desktop') {
                if (inBoxCaptionId === null) {
                    // был в боксе, вынули за пределы бокса
                    if (draggedCaption.boxId != '') {
                        let absolutePosition = {
                            x: lastX,
                            y: lastY,
                        }
                        this.props.dispatch(slideActions.addCaptionInBox(draggedCaption.index, '', absolutePosition))
                    }
                } else {
                    // был в одном боксе, стал в другом 
                    const newBoxPosition = newParentBoxElement.getBoundingClientRect()
                    let relativePosition = {
                        relativeX: (mainElemParams.x - newBoxPosition.x) / scale,
                        relativeY: (mainElemParams.y - newBoxPosition.y) / scale,
                    }
                    this.props.dispatch(slideActions.addCaptionInBox(draggedCaption.index, inBoxCaptionId, relativePosition))
                }
            }

        }
    }

    // показываем, что элемент можно поместить в бокс
    showDropableBox(index) {
        const workspaceElement = document.getElementById(`workspace`)
        const workspaceParams = workspaceElement.getBoundingClientRect()
        const mainElem = document.querySelector(`#caption-${index}`);
        setZindex(mainElem, true)
        let elemStartDragFromX = null
        let elemStartDragFromY = null

        // находим все элементы, в которые можно вложить
        const boxElementsList = workspaceElement.querySelectorAll('.caption-box')

        if (this.intervalFriends != null) clearInterval(this.intervalFriends)
        // интервал, с которым будем проверять совпадение элементов
        this.intervalFriends = setInterval(() => {
            if (this.props.viewType === 'mobile') {
                const currentWrapperElement = mainElem.closest('.react-draggable')
                const parentElement = currentWrapperElement.closest('.caption-box')
                if (parentElement) {
                    parentElement.classList.add('drop-in-me')
                }
                // предотвращаю смену вложенности по клику если перемещение ещё не начато
                // if(!this.state.isMoveElem) {
                //     this.setState({isMoveElem: true})
                // }
                return
                // continue
            }


            const mainElemParams = mainElem.getBoundingClientRect()
            const mainStartX = mainElemParams.x - workspaceParams.x
            const mainStartY = mainElemParams.y - workspaceParams.y
            const mainEndX = mainStartX + mainElemParams.width
            const mainEndY = mainStartY + mainElemParams.height
            const boxesArr = []
            const parentIndexArr = []

            // сохраняем стартовые координаты перетаскиваемого элемента, чтобы сравнить с координатами в последующих итерациях интервала
            if (elemStartDragFromX === null) elemStartDragFromX = mainStartX
            if (elemStartDragFromY === null) elemStartDragFromY = mainStartY

            // если перетаскиваемый элемент не сдвинут с места, а мышка на нём удерживается нажатой, то не выделяем бокс, в который можно вложить
            if (elemStartDragFromX === mainStartX && elemStartDragFromY === mainStartY) {
                return
            }

            // при каждом тике обходим список боксов и смотрим, помещается ли перетаскиваемый элемент в каждый из боксов
            for (let i = 0; i < boxElementsList.length; i++) {
                const boxElement = boxElementsList[i]
                // чтобы не выделять себя, пропускаем итерацию
                if (boxElement === mainElem) continue
                const { width, height, x, y } = boxElement.getBoundingClientRect()
                const boxStartX = x - workspaceParams.x
                const boxStartY = y - workspaceParams.y
                const boxEndX = boxStartX + width
                const boxEndY = boxStartY + height

                if (boxStartX <= mainStartX && boxEndX >= mainEndX && boxStartY <= mainStartY && boxEndY >= mainEndY) {

                    // новая логика (часть 1)
                    const currentWrapperElement = boxElement.closest('.react-draggable')
                    const parentElement = currentWrapperElement.closest('.caption-box')
                    if (!parentElement) {
                        const zIndex = +boxElement.getAttribute('data-caption-box-layer')
                        const megaParentObj = {
                            elem: boxElement,
                            zIndex,
                            captionId: +boxElement.getAttribute('id').split('-')[1]
                        }
                        // доюавляем боксы, которые являются коренными в иерархии вложенных боксов
                        boxesArr.push(megaParentObj)
                        parentIndexArr.push(zIndex)
                    }
                }
            }
            // 
            if (boxesArr.length) {
                // максимальный индекс
                const choosedIndex = Math.max.apply(null, parentIndexArr)
                // массив с элементами с максимальным индексом
                const filterMaxIndex = parentIndexArr.filter(index => index === choosedIndex)

                let choosedId = null
                // если элементов с одинаковым z-индексом 2 и более, то ищу среди них наибольший номер капчи
                if (filterMaxIndex.length > 0) {
                    // найти максимальный id среди равных z-index
                    const filteredMaxIndexArr = boxesArr.filter(obj => obj.zIndex === choosedIndex).map(obj => obj.captionId)

                    // id бокса, в который будет вложение
                    choosedId = Math.max.apply(null, filteredMaxIndexArr)
                }
                // обходим все боксы и удаляем у всех тень, если в него сейчас не вкладывается переносимый элемент
                // добавляем тень если вкладывается и если ещё нет
                for (let i = 0; i < boxElementsList.length; i++) {
                    const boxElement = boxElementsList[i]
                    // чтобы не выделять себя, пропускаем итерацию
                    if (boxElement === mainElem) continue
                    const captionId = +boxElement.getAttribute('id').split('-')[1]
                    if (captionId === choosedId) {

                        if (!boxElement.classList.contains('drop-in-me')) {
                            boxElement.classList.add('drop-in-me')
                        }
                    } else if (boxElement.classList.contains('drop-in-me')) {
                        boxElement.classList.remove('drop-in-me')
                    }
                }
            } else {
                // если не помещается ни в один бокс, то удаляем у всех тень
                for (let i = 0; i < boxElementsList.length; i++) {
                    const boxElement = boxElementsList[i]
                    // чтобы не выделять себя, пропускаем итерацию
                    if (boxElement === mainElem) continue
                    if (boxElement.classList.contains('drop-in-me')) {
                        boxElement.classList.remove('drop-in-me')
                    }

                }
            }

            // предотвращаю смену вложенности по клику если перемещение ещё не начато
            // if(!this.state.isMoveElem) {
            //     this.setState({isMoveElem: true})
            // }
        }, 50)
    }

    // этот метод не используется
    // convertAndChangePositionV2(draggedCaption, lastX, lastY) {
    //     // console.log('draggedCaption',draggedCaption);
    //     const captions = store.getState().slideReducer.captions;
    //     const workspace = document.getElementById(`workspace`).getBoundingClientRect()
    //     let widthProperty = this.props.viewType === 'desktop' ? 'width' : 'mobileWidth';
    //     let heightProperty = this.props.viewType === 'desktop' ? 'height' : 'mobileHeight';
    //     let boxsInDom = new Map()
    //     let minBoxZone = {
    //         x1: 0,
    //         x2: 10000,
    //         y1: 0,
    //         y2: 10000,
    //         index: null,
    //         id: null,
    //     }
    //     // debugger



    //     captions.map((caption, captionIndex) => {

    //         if (caption.type === 'box' && caption.id != draggedCaption.id) {
    //             let boxInDom = document.getElementById(`caption-${caption.index}`).getBoundingClientRect()
    //             boxInDom.x -= workspace.x
    //             boxInDom.y -= workspace.y

    //             boxsInDom.set(caption.id, boxInDom)
    //             let boxZone = {
    //                 x1: boxInDom.x,
    //                 x2: boxInDom.x + boxInDom.width,
    //                 y1: boxInDom.y,
    //                 y2: boxInDom.y + boxInDom.height,
    //                 index: caption.index,
    //                 id: caption.id,
    //             }

    //             if ((lastX >= boxZone.x1 && lastX + draggedCaption[widthProperty] <= boxZone.x2)
    //                 &&
    //                 (lastY >= boxZone.y1 && lastY + draggedCaption[heightProperty] <= boxZone.y2)) {

    //                 if ((boxZone.x2 - boxZone.x1 <= minBoxZone.x2 - minBoxZone.x1)
    //                     ||
    //                     (boxZone.y2 - boxZone.y1 <= minBoxZone.y2 - minBoxZone.y1)) {
    //                     minBoxZone.x1 = boxZone.x1
    //                     minBoxZone.x2 = boxZone.x2
    //                     minBoxZone.y1 = boxZone.y1
    //                     minBoxZone.y2 = boxZone.y2
    //                     minBoxZone.index = boxZone.index
    //                     minBoxZone.id = boxZone.id

    //                 }
    //             }
    //         }
    //     })
    //     if (draggedCaption.boxId != minBoxZone.id) {
    //         if (this.props.viewType === 'desktop') {
    //             if (minBoxZone.id === null) {
    //                 if (draggedCaption.boxId != '') {
    //                     let absolutePosition = {
    //                         x: lastX,
    //                         y: lastY,
    //                     }

    //                     this.props.dispatch(slideActions.addCaptionInBox(draggedCaption.index, '', absolutePosition))
    //                 }
    //             } else {
    //                 let relativePosition = {
    //                     relativeX: lastX - minBoxZone.x1,
    //                     relativeY: lastY - minBoxZone.y1,
    //                 }
    //                 this.props.dispatch(slideActions.addCaptionInBox(draggedCaption.index, minBoxZone.id, relativePosition))
    //             }
    //         }
    //     } else {

    //         lastX = lastX - minBoxZone.x1;
    //         lastY = lastY - minBoxZone.y1;

    //         this.props.dispatch(slideActions.changeCaptionRelativePosition(draggedCaption.index, lastX, lastY,
    //             this.props.viewType))
    //     }

    // }





    addSelectedCaption(e, index) {
        // console.log('addSelectedCaption',index);
        // логика выделения с ctrl перенесена в Captions/index.js, или уже нет. Там с textPanel
        if (this.props.selected) {
            // console.log('this.props.ctrlIsPress',this.props.ctrlIsPress);
            // console.log('e.ctrlKey',e.ctrlKey);
            if (this.props.ctrlIsPress) {
                // console.log('ctrlIsPress1',index); 
                if (this.props.captionSelectedArray.length === 1) {

                    this.props.dispatch(menuActions.changeEditingCaptionIndex(null))
                    this.props.dispatch(menuActions.unselectCaption(index))
                }
            }
        } else {
            if (this.props.ctrlIsPress) {
                if (this.props.captionSelectedArray.length > 0) {
                    // если уже есть выделенные элементы, то проверяем чтобы новая капча 
                    // была прямым потомком только одного бокса с уже выделенными элементами
                    const sameParentBox = this.props.captions[this.props.captionSelectedArray[0]].boxId === this.props.captions[index].boxId
                    if (sameParentBox) {
                        // console.log('addSelectedCaption', index);
                        // this.props.dispatch(menuActions.changeEditingCaptionIndex(index))
                        this.props.dispatch(menuActions.addSelectedCaption(index))
                    }
                } else {
                    this.props.dispatch(menuActions.changeEditingCaptionIndex(index))
                    this.props.dispatch(menuActions.addSelectedCaption(index))
                }
                // если в боксе
                // if (this.props.captions[index].boxId) {
                //     // проверяем чтобы выделенные капчи были прямыми потомками только одного бокса
                //     console.log('ctrlIsPress2',index);
                //     console.log('captions',this.props.captions);
                //     const sameParentBox = this.props.captions[this.props.captionSelectedArray[0]].boxId === this.props.captions[index].boxId
                //     console.log('sameParentBox',sameParentBox);
                //     if (sameParentBox) {

                //         this.props.dispatch(menuActions.changeEditingCaptionIndex(index))
                //         this.props.dispatch(menuActions.addSelectedCaption(index))
                //     }


                // } else {
                //     // this.props.dispatch(menuActions.changeEditingCaptionIndex(index))
                //     this.props.dispatch(menuActions.addSelectedCaption(index))
                // }

            } else {
                if (this.props.tempStyle != null) {
                    // console.log('applyStyle');
                    this.props.dispatch(slideActions.applyStyle(this.props.tempStyle, index))

                    const captionType = this.props.captions[index].type
                    if (captionType === 'text' || captionType === 'button') {

                        // после изменения стилей получить изменившиеся размеры капчи
                        setTimeout(() => {
                            this.props.dispatch(slideActions.changeArrayCaptionsDimesions([index]))
                            this.props.dispatch(slideActions.addAction())
                        }, 400)
                    } else {
                        this.props.dispatch(slideActions.addAction())
                    }
                }
                // console.log('chooseAnotherOneCaption',index);
                // веделяем новую капчу
                // this.props.dispatch(menuActions.clearSelectedCaption())
                // this.props.dispatch(menuActions.changeEditingCaptionIndex(index))
                // this.props.dispatch(menuActions.addSelectedCaption(index))
                this.props.dispatch(menuActions.chooseAnotherOneCaption(index))
            }
        }
    }

    // открытие контекстного меню по двойному клику на тексте или кнопке
    doubleClickHandler(e) {
        let rightclick
        // проверяю, не правой ли кнопкой клик
        if (e.which) rightclick = (e.which == 3);
        else if (e.button) rightclick = (e.button == 2);
        // если правой, то не учитываем его в двойном клике
        if (rightclick) return
        if (this.props.editingCaptionIndex === this.props.index && this.props.editingText) return

        if (this.state.click) {
            this.setState({ click: false })
            this.props.switchEditTextPanel(e, this.props.captionIndex, this.props.selected)
            // setTimeout(() => {
            //     console.log(document.querySelector('.text'));
            //     document.querySelector('.text').focus()
            //     var el = document.querySelector('.text');
            //     selectElementContents(el);
            // },10)
        } else {
            this.setState({ click: true })
            setTimeout(() => {
                if (this.isUnmounted) return
                this.setState({ click: false })
            }, 350)
        }
    }

    render() {
        // if (this.props.gridOn) {
        // this.props.position.x = this.roundCaptionForGrid(this.props.position.x, 1)
        //     this.props.position.y = this.roundCaptionForGrid(this.props.position.y, 1)
        // }
        // учитываем увеличение лупой на мобильном виде
        const mobileViewScale = (this.props.mobileViewScale / 100)

        return (
            <Draggable
                // key со значениями позиций по x и y приводит к ошибке Warning: setState(...): Can only update a mounted or mounting component
                // а отсутствие этих значений приводит к тому, что после передвижения элемента стрелками потом, при попытке перетащить мышкой,
                // элемент рендерится на своём прежнем месте. Поэтому стал использовать captionRandomKey
                // key={'draggable-wrapper-' + this.props.index + this.props.position.x + this.props.position.y}
                key={'draggable-wrapper-' + this.props.index + this.props.captionRandomKey}
                defaultPosition={this.props.position}
                disabled={this.props.previewSlide || this.props.editingText || (this.props.captionSelectedArray.length > 1 && this.props.selected)}
                position={this.props.position}
                grid={this.props.shiftIsPress || this.props.gridOn ? [10, 10] : this.props.currentGrid}
                // grid={(this.props.shiftIsPress || this.props.gridOn) ? [10, 10] : [1, 1]}
                // bounds={getBounds(event, this.props.index) || '#workspace'}
                // bounds={getBounds(event, this.props.index, this.props.angle) || '#workspace'}
                onStart={(e) => {
                    e.stopPropagation();
                    this.setState({
                        startDragTime: Date.now(),
                        startDragMouseX: e.clientX,
                        startDragMouseY: e.clientY,
                    })
                    // console.log('ctrl',e.ctrlKey);
                    this.showDropableBox(this.props.index);
                    this.addSelectedCaption(e, this.props.index)
                }}
                // onStart={(e) => this.addSelectedCaption(this.props.index)}
                onStop={(event, data) => {
                    // чтобы провести грань между кликом и перетаскиванием задаю время,
                    // время перетаскивания меньше которого, приравнивается клику и капча не перемещается
                    const timeFromStartIsLittle = Date.now() - this.state.startDragTime < 200
                    this.changeCaptionPosition(this.props.index, data.lastX, data.lastY, event, timeFromStartIsLittle)
                    if (this.props.onDragStop && !this.props.editingText) {
                        this.props.onDragStop(event, data)
                    }
                }}
                cancel={this.props.cancel}
                scale={mobileViewScale}
                onMouseDown={(e) => {
                    // e.stopPropagation(); -предотвращает перетаскивание в unvisibleBox
                    // если текст или кнопка, то открываем контекстное меню по двойному клику
                    if (this.props.switchEditTextPanel) {
                        this.doubleClickHandler(e)
                    }
                    // false - не выделена, true - выделена, undefined - находтися внутри бокса, может быть либо выделена, либо нет
                    if (this.props.inUnvisibleBox !== false) {
                        // в случае невидимого бокса снимаем выделение с капчи при нажатом ctrl
                        if (this.props.ctrlIsPress) {
                            this.props.unselectCaption(e, this.props.index, this.props.selected)
                        }
                        // или меняем редактируемую капчу среди выделенных
                        else if (this.props.index !== this.props.editingCaptionIndex && this.props.captionSelectedArray.some(i => i === this.props.index)) {
                            this.props.dispatch(menuActions.changeEditingCaptionIndex(this.props.index))
                        }

                    }
                }}
                onDrag={(event, data) => {
                    if (this.props.onDrag && !this.props.editingText) {
                        this.props.onDrag(event, data)
                    }
                }}
            >

                {this.props.children}

            </Draggable>
        )
    }
}

function mapStateToProps(state) {
    return {
        widgetData: state.slideReducer.widgetData,
        captions: state.slideReducer.captions,
        rulers: state.menuReducer.rulers,
        rulersArray: state.menuReducer.rulersArray,
        rulersArrayMobile: state.menuReducer.rulersArrayMobile,
        editingText: state.menuReducer.editingText,
        shiftIsPress: state.menuReducer.shiftIsPress,
        ctrlIsPress: state.menuReducer.ctrlIsPress,
        gridOn: state.menuReducer.gridOn,
        captionSelectedArray: state.menuReducer.captionSelectedArray,
        viewType: state.menuReducer.viewType,
        slideIndex: state.slideReducer.index,
        editingCaptionIndex: state.menuReducer.editingCaptionIndex,
        previewSlide: state.menuReducer.previewSlide,
        mobileViewScale: state.menuReducer.mobileViewScale,
        tempStyle: state.menuReducer.tempStyle,
    }
}

export default connect(mapStateToProps)(DraggableWrapper)